module.exports = __webpack_public_path__ + "img/hr-red-pita-09.7b58317e.png";